module.exports = __webpack_public_path__ + "img/bx-class-choosing-report.c276deed.svg";